import { render } from "./ourteam.vue?vue&type=template&id=265c794a&scoped=true"
import script from "./ourteam.vue?vue&type=script&lang=js"
export * from "./ourteam.vue?vue&type=script&lang=js"

import "./ourteam.vue?vue&type=style&index=0&id=265c794a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-265c794a"

export default script